<template>
  <div>

    <div v-if="isGettingSignedURL" class="text-center mt-5 mb-5">
      <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
    </div>

    <div v-else>
      <b-alert :show="dismissCountDown"
               dismissible
               fade
               class="mt-2"
               variant="danger"
               @dismissed="dismissCountDown=0"
               @dismiss-count-down="handleCountDownChange">
        Please choose a valid csv file ....
        <i class="small">alert will disappear in {{dismissCountDown}} seconds</i>
      </b-alert>

      <label class="file-select" v-if="!inProgress">
        <div class="select-button">
          <span v-if="file">Select Different File</span>
          <span v-else>Select File</span>
        </div>
        <input type="file" @change="handleFileChange"/>
      </label>

      <p v-if="file">Selected File: {{file.name}}</p>
      <b-progress variant="primary" striped animated class="mb-2" v-if="inProgress">
        <b-progress-bar :value="percentComplete">
          <strong>{{ percentComplete.toFixed(1) }} %</strong>
        </b-progress-bar>
      </b-progress>

      <div>
        <b-button variant="danger"
                  v-if="inProgress"
                  @click.prevent="handleStopUpload">
          <i class="fa fa-stop" aria-hidden="true"></i>
          Stop Upload
        </b-button>
        <b-button variant="success"
                  v-else
                  @click.prevent="handleStartUpload"
                  :disabled="!file">
          <i class="fa fa-arrow-up" aria-hidden="true"></i>
          Start Upload
        </b-button>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
	import {fullURL} from '../../utils';

  export default {
    name: 'S3Upload',

    data() {
      return {
        file: null,

        isGettingSignedURL: true,
        uploadURL: '',
        uploadData: {},
        percentComplete: -1,

        dismissCountDown: 0,
        cancelUploadFn: null
      };
    },


    mounted() {
      this.isGettingSignedURL = true;
      axios.get(fullURL('s3_signed_post'))
        .then(({data: {fields, url}}) => {
          this.uploadURL = url;
          this.uploadData = fields;
        })
        .catch(console.log)
        .finally(() => { this.isGettingSignedURL = false; });
    },

    computed: {
      inProgress() {
        return this.percentComplete > -1;
      }
    },

    methods: {
      onProgress({loaded}) {
        const completed = loaded / this.file.size;
        this.percentComplete = Math.min(completed, 1) * 100;
      },

      onComplete() {
        this.$emit('complete', {
          id: this.uploadData.key,
          originalName: this.file.name,
          size: this.file.size
        });
      },

      onError(err) {
        this.$emit('error');
        console.log('FAILURE!!');
        console.log(err);
      },


      handleCountDownChange(dismissCountDown) {
        this.dismissCountDown = dismissCountDown;
      },

      handleStopUpload() {
        if (this.cancelUploadFn) this.cancelUploadFn();
      },

      handleStartUpload() {
        const formData = new FormData();
        Object.keys(this.uploadData).forEach(key => formData.set(key, this.uploadData[key]));
        formData.append('file', this.file, this.uploadData.key);

        const config = {
          onUploadProgress: this.onProgress,
          headers: {'Content-Type': 'multipart/form-data'},
          cancelToken: new axios.CancelToken((c) => { this.cancelUploadFn = c; })
        };

        this.$emit('start');

        this.percentComplete = 0;
        axios.post(this.uploadURL, formData, config)
          .then(this.onComplete)
          .catch(this.onError);
      },

      handleFileChange(e) {
        const file = e.target.files[0];
        if (!/\.(csv)$/i.test(file.name)) this.dismissCountDown = 10;
        else this.file = file;
      }
    }
  };
</script>

<style scoped lang="scss">
  .file-select {
    display: block;

    .select-button {
      padding: 1rem;
      max-width: 280px;
      border-radius: .3rem;
      border: 2px dashed gray;
      text-align: center;
      font-weight: bold;
    }

    input[type="file"] {
      display: none;
    }
  }
</style>
